import { useToast } from 'native-base';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import Returns from './Returns';
import store from '../../../store';

function ReturnsContainer({ onStepSet }) {
  const cost = useSelector((state) => state.wallet.cost);
  const paymentTotal = useSelector(store.select.wallet.paymentTotal);
  const returnTotal = useSelector(store.select.wallet.returnTotal);
  const remaining = paymentTotal - cost - returnTotal;
  const returnContent = useSelector((state) => state.wallet.returnContent);
  const onreturnAdd = store.dispatch.wallet.returnAdd;
  const onreturnSub = store.dispatch.wallet.returnSub;
  const toast = useToast();
  const onDone = useCallback(() => {
    if (remaining > 0) {
      toast.show({
        title: 'Toute la monnaie ne vous a pas encore été rendue.',
        placement: 'top',
        status: 'error',
      });
    } else if (remaining < 0) {
      toast.show({
        title: 'Il vous a été rendu trop de monnaie.',
        placement: 'top',
        status: 'error',
      });
    } else {
      onStepSet(4);
    }
  }, [onStepSet, remaining, toast]);
  return (
    <Returns
      onDone={onDone}
      onreturnAdd={onreturnAdd}
      onreturnSub={onreturnSub}
      remaining={remaining}
      returnContent={returnContent}
    />
  );
}

ReturnsContainer.propTypes = {
  onStepSet: PropTypes.func.isRequired,
};

export default ReturnsContainer;
